import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const manageOfferValidationSchema = (t, props) => ({
  title: yup
    .string()
    .required(t(translations.validation.required()))
    .max(70, t(translations.validation.max(), { max: 70 }))
    .label(t(translations.common.title())),
  startDate: yup
    .string()
    .required(t(translations.validation.required()))
    .label(t(translations.pages.jobOffers.startDate())),
  description: yup
    .string()
    .required(t(translations.validation.required()))
    .label(t(translations.common.description())),
  courses: yup
    .array()
    .of(yup.object())
    .min(1, t(translations.validation.minOne()))
    .label(t(translations.common.courses())),
  attachement: yup.mixed(),
  jobTypeId: props.newOffer
    ? yup.number().required(t(translations.validation.required()))
    : yup.number(),
  jobPriceId: yup
    .string()
    .required(t(translations.validation.required()))
    .label(t(translations.pages.manageJobOffers.priceCategories())),
  periodStart: props.newOffer
    ? yup
        .string()
        .required()
        .typeError(t(translations.validation.required()))
        .label(t(translations.pages.manageJobOffers.periodStart()))
    : yup.string(),
  externalLink: yup
    .string()
    .url(t(translations.validation.homepage()))
    .label(t(translations.pages.manageJobOffers.externalLink()))
});
